import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Hero from '@/components/Hero';
import SectionTitle from '@/components/SectionTitle';
import ProcessStep from '@/components/ProcessStep';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Scale, FileText, Building2, Home, Phone, ClipboardList, ShieldCheck, Briefcase, ClipboardCheck, CheckCircle } from 'lucide-react';
import aboutImage from '@/assets/about-image.jpg';
import { Card, CardContent } from "@/components/ui/card";
import success1 from '@/assets/successes/success-1.jpg';
import success2 from '@/assets/successes/success-2.jpg';
import success3 from '@/assets/successes/success-3.jpg';
import success4 from '@/assets/successes/success-4.jpg';
import success5 from '@/assets/successes/success-5.jpg';
import success6 from '@/assets/successes/success-6.jpg';
import success7 from '@/assets/successes/success-7.jpg';
import success8 from '@/assets/successes/success-8.jpg';
import success9 from '@/assets/successes/success-9.jpg';
import success10 from '@/assets/successes/success-10.jpg';
const Index = () => {
  const [showAllSuccesses, setShowAllSuccesses] = useState(false);

  // Practice areas data
  const practiceAreas = [{
    id: 'execution',
    title: 'הוצאה לפועל',
    description: 'ייצוג וליווי מקצועי בהליכי הוצאה לפועל, גביית חובות ואכיפת פסקי דין. מתן פתרונות יעילים להבטחת זכויות הלקוחות.',
    icon: Scale
  }, {
    id: 'bankruptcy',
    title: 'חדלות פירעון',
    description: 'ייצוג בהליכי חדלות פירעון, הסדרי נושים ופירוק חברות. ייעוץ אסטרטגי לצמצום נזקים ומציאת פתרונות משפטיים יעילים.',
    icon: Building2
  }, {
    id: 'real-estate',
    title: 'מקרקעין',
    description: 'ליווי עסקאות מקרקעין, הסכמי מכר ורכישה, בדיקות משפטיות ורישום זכויות. טיפול מקיף בכל היבטי דיני המקרקעין.',
    icon: Home
  }];

  // Rotating texts data
  const rotatingTexts = ['חדלות פירעון', 'הסדר נושים', 'מקרקעין'];

  // Process steps data
  const processSteps = [{
    id: 1,
    title: 'שיחת אבחון ראשונית',
    description: 'בדיקת המצב הפיננסי והתאמה להליך',
    icon: Phone
  }, {
    id: 2,
    title: 'גיבוש אסטרטגיה ואיסוף מסמכים',
    description: 'אנחנו מכינים את כל מה שצריך',
    icon: ClipboardList
  }, {
    id: 3,
    title: 'הגשת הבקשה ועיכוב הליכים',
    description: 'עוצרים מיידית את העיקולים והטלפונים',
    icon: ShieldCheck
  }, {
    id: 4,
    title: 'ניהול ההליך וייצוג מלא',
    description: 'אנחנו מטפלים עבורך בבירוקרטיה מול הנאמן ובית המשפט',
    icon: Briefcase
  }, {
    id: 5,
    title: 'גיבוש תוכנית שיקום מותאמת',
    description: 'מוודאים שתקבל תנאים שתוכל לעמוד בהם',
    icon: ClipboardCheck
  }, {
    id: 6,
    title: 'קבלת הפטר וסיום החובות!',
    description: 'יוצאים לדרך כלכלית חדשה ונקייה',
    icon: CheckCircle
  }];

  // Success images
  const successImages = [success1, success2, success3, success4, success5, success6, success7, success8, success9, success10];
  return <div className="min-h-screen">
      {/* Hero Section - updated with even whiter background */}
      <Hero title="A|S|Z&CO" // Updated to new firm name format without period
    subtitle="פתרונות משפטיים מקצועיים עם גישה אישית ואחראית" image="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?q=80&w=2070&auto=format&fit=crop" height="full" rotatingTexts={rotatingTexts} darkText={true} overlayOpacity={0.95} />

      {/* About Section */}
      <section id="about-section" className="py-20 bg-white">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div className="order-2 md:order-1">
              <div className="prose max-w-none text-right">
                <h2 className="text-3xl font-light mb-6">אודות המשרד</h2>
                <p className="text-gray-600 mb-4">משרדנו עוסק בייצוג משפטי בתחומי המקרקעין, מיסוי מקרקעין, חדלות פירעון והוצאה לפועל, ומלווה לקוחות פרטיים ועסקיים בתהליכים מורכבים של מכירה, ירושה, פירוק שיתוף, גבייה והסתבכויות כלכליות .

              </p>
                
                <Link to="/about">
                  <Button variant="outline" className="border-black text-black hover:bg-black hover:text-white">
                    קרא עוד
                    <ArrowLeft size={16} className="mr-2" />
                  </Button>
                </Link>
              </div>
            </div>
            <div className="order-1 md:order-2 relative">
              <img src={aboutImage} alt="משרד עורכי דין" className="w-full h-[400px] object-cover" style={{
              maskImage: 'linear-gradient(to right, transparent, black 5%, black 95%, transparent)',
              WebkitMaskImage: 'linear-gradient(to right, transparent, black 5%, black 95%, transparent)'
            }} />
            </div>
          </div>
        </div>
      </section>

      {/* Practice Areas */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 md:px-6">
          <SectionTitle title="תחומי התמחות" subtitle="מומחיות משפטית מובילה במגוון תחומים" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {practiceAreas.map(area => {
            const IconComponent = area.icon;
            return <div key={area.id} className="bg-white p-8 transition-all duration-300 hover:shadow-lg group">
                  
                  <h3 className="text-xl font-medium mb-4 text-center">{area.title}</h3>
                  <p className="text-gray-600 text-center leading-relaxed text-sm">
                    {area.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </section>

      {/* Office Successes Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 md:px-6">
          <SectionTitle title="חלק מההצלחות המשרד" subtitle="תיקים שטיפלנו בהם בהצלחה עבור לקוחותינו" />
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12 max-w-6xl mx-auto">
            {successImages.slice(0, showAllSuccesses ? successImages.length : 1).map((image, index) => <Card key={`success-${index}`} className="group overflow-hidden bg-white shadow-md hover:shadow-2xl transition-all duration-500 animate-fade-in" style={{
            animationDelay: `${index * 0.1}s`
          }}>
                <CardContent className="p-0">
                  <div className="relative w-full h-[400px] md:h-[500px] bg-gray-50 overflow-hidden">
                    <img src={image} alt={`הצלחה ${index + 1} של משרד עורכי דין`} className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                    
                  </div>
                </CardContent>
              </Card>)}
          </div>

          {!showAllSuccesses && <div className="flex justify-center mt-8">
              <Button onClick={() => setShowAllSuccesses(true)} variant="outline" size="lg" className="border-2 border-black text-black hover:bg-black hover:text-white transition-all duration-300">
                הצג עוד
                <ArrowLeft size={16} className="mr-2" />
              </Button>
            </div>}
        </div>
      </section>

      {/* Eligibility Calculator CTA */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-light mb-4">בדקו את הזכאות שלכם</h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            מחשבון זכאות לחדלות פירעון - קבלו תשובה מיידית האם אתם זכאים להליך
          </p>
          <a href="https://mahshevon.lovable.app/" target="_blank" rel="noopener noreferrer">
            <Button size="lg" variant="outline" className="border-2 hover:bg-gray-100">
              למחשבון הזכאות
              <ArrowLeft size={16} className="mr-2" />
            </Button>
          </a>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 md:px-6">
          <SectionTitle title="המסע לחופש כלכלי" subtitle="תהליך מובנה ומקצועי שמלווה אותך בכל צעד" />

          <div className="flex flex-col gap-8 mt-16 max-w-3xl mx-auto">
            {processSteps.map((step, index) => <ProcessStep key={step.id} stepNumber={step.id} title={step.title} description={step.description} icon={step.icon} isLast={index === processSteps.length - 1} />)}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-12 bg-black text-white">
        <div className="container mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-light mb-6">מעוניינים לשמוע עוד?</h2>
          <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
            צרו איתנו קשר לפגישת היכרות ונשמח לדון בפרויקט הבא שלכם
          </p>
          <Link to="/contact">
            <Button className="bg-white text-black hover:bg-gray-200">
              צור קשר
              <ArrowLeft size={16} className="mr-2" />
            </Button>
          </Link>
        </div>
      </section>
    </div>;
};
export default Index;